import React from "react";
import classnames from "classnames";
import { getS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";
import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";
import { ClickRatePopover } from "common/Components/ClickRatePopover";
import { STATS_FIELDS, POPOVER_TEXT } from "../../EmailListItem.constants";

export const MobileDataItem = ({
  data,
  subData,
  title,
  titleClassName,
  color,
  icon,
  tooltipText,
  popoverText,
  className,
}) => {
  return (
    <div
      className={classnames(
        "tw-flex tw-items-center tw-w-full tw-bg-[#FBFBFB] tw-rounded-lg tw-p-3 tw-gap-2",
        className
      )}
    >
      <div className="tw-flex tw-justify-center">
        <div
          className="tw-flex tw-flex-col tw-rounded-[10px] tw-p-[10px]"
          style={{
            backgroundColor: `${color}33`, // ~20% opacity
          }}
        >
          <ExlyImage
            src={getS3AssetCDNUrl(`assets/vectors/dashboard/${icon}`)}
            width={22}
            height={22}
            style={{ color }}
          />
        </div>
      </div>

      <div className="tw-flex tw-flex-col">
        <div className="tw-flex tw-flex-row tw-gap-1">
          <div
            className={classnames(
              "tw-text-[10px] tw-font-normal tw-text-[#272522] tw-uppercase",
              titleClassName
            )}
          >
            {title}
          </div>

          {tooltipText && (
            <ClickRatePopover
              tooltipText={tooltipText}
              popoverText={popoverText || POPOVER_TEXT}
              shouldAutoOpen={title === STATS_FIELDS.clickRate}
            />
          )}
        </div>

        <div className="tw-flex tw-items-center tw-gap-1">
          <div className="tw-text-[16px] tw-font-medium" style={{ color }}>
            {data}
          </div>

          {subData != null && (
            <div className="tw-text-[12px] tw-font-normal" style={{ color }}>
              ({subData})
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
